export default __webpack_public_path__ + "static/media/eth-logo.2dcd9502.svg";